import { TreeGrid, Reorder as TreeGridReorder } from '@syncfusion/ej2-treegrid';
/**
 * To handle column reorder action from TreeGrid
 */
export class Reorder {
    constructor(gantt) {
        this.parent = gantt;
        TreeGrid.Inject(TreeGridReorder);
        this.parent.treeGrid.allowReordering = this.parent.allowReordering;
        this.bindEvents();
    }
    /**
     * Get module name
     *
     * @returns {string} .
     */
    getModuleName() {
        return 'reorder';
    }
    /**
     * To bind reorder events.
     *
     * @returns {void} .
     * @private
     */
    bindEvents() {
        this.parent.treeGrid.columnDragStart = (args) => {
            this.parent.trigger('columnDragStart', args);
        };
        this.parent.treeGrid.columnDrag = (args) => {
            this.parent.trigger('columnDrag', args);
        };
        this.parent.treeGrid.columnDrop = (args) => {
            this.parent.trigger('columnDrop', args);
        };
    }
    /**
     * To destroy the column-reorder.
     *
     * @returns {void} .
     * @private
     */
    destroy() {
        // Destroy Method
    }
}
